export default __webpack_public_path__ + "static/media/android.d5b3a13e.png";